import $ from 'jquery';
import 'select2/dist/css/select2.css';
import 'select2';

import 'select2-bootstrap-5-theme/dist/select2-bootstrap-5-theme.css';
$.fn.select2.defaults.set("theme", "bootstrap-5");
